import React from 'react'
import { Box } from '@node-space/storybook-components/dist/Box'
import { MassPayoutFileUpload } from '../components/FileUpload/MassPayoutFileUpload'
import MassPayoutModal from '../components/MassPayoutModal'
import { MassPayoutSubmitButton } from '../components/MassPayoutSubmitButton'
import { MassPayoutTypeSelection } from '../components/MassPayoutTypeSelection'
import { MassPayoutWalletSelection } from '../components/MassPayoutWalletSelection'

export const MassPayoutsUploadForm = () => {
  return (
    <Box flex direction="col" width="full">
      <Box flex direction="col" className="justify-center items-center gap-y-6 w-full">
        <Box flex direction="col" className="gap-y-6 w-100">
          <MassPayoutTypeSelection />
          <MassPayoutWalletSelection />
          <MassPayoutFileUpload />
          <MassPayoutSubmitButton />
          <MassPayoutModal />
        </Box>
      </Box>
    </Box>
  )
}
